module.exports = __webpack_public_path__ + "media/images/emblems/Veytaux-coat_of_arms-1f15d164ca11ec6214b5c0c74277ee6c.svg";